// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yJP8","image":"Header_image__1EKiG","name":"Header_name__3ZOKC","info":"Header_info__3CHnM","infoRow":"Header_infoRow__3vf74"};